import React from 'react';
import { Award, Clock, Heart } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-soft-gray">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Photo */}
          <div className="order-2 md:order-1">
            <div className="relative">
              <div className="absolute -inset-4 bg-warm-sage/20 rounded-2xl transform rotate-3"></div>
              <img
                src="/images/elina.jpg"
                alt="Элина - психолог"
                className="relative rounded-2xl shadow-2xl w-full object-cover aspect-[3/4]"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-6">
              Кто я?
            </h2>
            <p className="text-lg text-warm-gray mb-8 leading-relaxed">
              Я – профессиональный психолог с высшим медицинским образованием.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-warm-sage/20 flex items-center justify-center flex-shrink-0">
                  <Heart className="text-warm-sage" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-charcoal mb-1">Помогаю людям</h3>
                  <p className="text-warm-gray text-sm">
                    Справляться с трудностями, повышать качество жизни и находить себя
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-warm-sage/20 flex items-center justify-center flex-shrink-0">
                  <Clock className="text-warm-sage" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-charcoal mb-1">Опыт работы</h3>
                  <p className="text-warm-gray text-sm">
                    Более 1500 часов работы с клиентами
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full bg-warm-sage/20 flex items-center justify-center flex-shrink-0">
                  <Award className="text-warm-sage" size={24} />
                </div>
                <div>
                  <h3 className="font-semibold text-charcoal mb-1">Модальность</h3>
                  <p className="text-warm-gray text-sm">
                    Работаю с любым запросом в модальности "рилив"
                  </p>
                </div>
              </div>
            </div>

            <a href="#consultation" className="btn-primary inline-flex items-center">
              Записаться на консультацию
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
